// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kh-0";
export var fileList = "_kh-2";
export var removeFileButton = "_kh-1";